<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="1000px"
      scrollable
      @keydown="executeCloseModalCreateSupplier"
      @click:outside="executeCloseModalCreateSupplier"
    >
      <v-card>
        <div class="p-4 pb-0">
          <v-tabs fixed-tabs centered v-model="tab" active-class="bg-primary">
            <v-tab
              id="formSupplier"
              class="tab-list"
              key="fiabilityData"
              active-class="bg-app-primary text-white rounded"
              >1.Datos del Proveedor</v-tab
            >
            <v-tab
              id="documentsSupplier"
              class="tab-list"
              active-class="bg-app-primary text-white rounded"
              key="previewDocuments"
              >2.Documentos del Proveedor</v-tab
            >
          </v-tabs>
        </div>
        <hr />
        <v-card-text>
          <v-container class="">
            <v-tabs-items v-model="tab">
              <v-tab-item key="formSupplier">
                <v-form @submit.prevent="sendAddSupplier">
                  <v-row align-content="center">
                    <h4 class="my-3">Información de la Empresa</h4>
                    <hr />
                    <v-col cols="12" md="12" sm="12">
                      <label for="reason_name"> Razón Social * </label>
                      <v-text-field
                        placeholder="Ingresa la Razón Social del Proveedor"
                        v-model="$v.form.reason_name.$model"
                        :error="$v.form.reason_name.$invalid && submitUpload"
                        :error-messages="
                          $v.form.reason_name.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pt-0">
                      <label for="supplier_rut" class="mt-1">
                        Rut del Proveedor *
                      </label>
                      <v-text-field
                        placeholder="Ingrese el RUT del proveedor"
                        v-model="form.supplier_rut"
                        @keypress="validateRutFormat"
                        @paste="validateRutFormat"
                        :error="
                          $v.form.supplier_rut.$invalid &&
                            $v.form.supplier_rut.$model !== null
                        "
                        :error-messages="
                          $v.form.supplier_rut.$invalid &&
                          $v.form.supplier_rut.$model
                            ? 'El RUT ingresado no es válido'
                            : null
                        "
                        @input="formatRut"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" sm="12" class="pt-0">
                      <label class="mt-1"> Giro del Proveedor * </label>
                      <v-autocomplete
                        placeholder="Ingresa el giro del proveedor"
                        v-model="$v.form.supplier_draft.$model"
                        :error="$v.form.supplier_draft.$invalid && submitUpload"
                        :error-messages="
                          $v.form.supplier_draft.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        :items="allSupplierDrafts"
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="company_contact">
                        Persona de Contacto en la Empresa *
                      </label>
                      <v-text-field
                        placeholder="Ingresa la persona de contacto de la empresa"
                        v-model="form.company_contact"
                        :error="
                          $v.form.company_contact.$invalid && submitUpload
                        "
                        :error-messages="
                          $v.form.company_contact.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="company_phone">
                        Teléfono del Contacto *</label
                      >
                      <v-text-field
                        @keypress="validatePhone"
                        @paste="validatePhone"
                        placeholder="Ingresa el teléfono del contacto"
                        v-model="$v.form.company_phone.$model"
                        :error="$v.form.company_phone.$invalid && submitUpload"
                        :error-messages="
                          $v.form.company_phone.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="company_email">
                        Correo Electrónico del Contacto *
                      </label>
                      <v-text-field
                        placeholder="Ingresa el correo del contacto"
                        v-model="form.company_email"
                        :error="$v.form.company_email.$invalid && submitUpload"
                        :error-messages="
                          $v.form.company_email.$invalid && submitUpload
                            ? 'Este campo debe ser un correo electrónico válido'
                            : null
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" v-if="showAllForm">
                      <label for="address"> Dirección * </label>
                      <v-textarea
                        rows="2"
                        counter
                        placeholder="Ingresa la Dirección del Proveedor"
                        v-model="$v.form.address.$model"
                        :error="
                          ((form.address && form.address.length > 50) ||
                            $v.form.address.$invalid) &&
                            submitUpload
                        "
                        :error-messages="
                          form.address && form.address.length > 50
                            ? 'Ingrese un máximo de 50 caracteres'
                            : $v.form.address.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                      ></v-textarea>
                    </v-col>
                    <!-- <v-col
                      v-if="form.is_foreign"
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                    >
                      <label for="country"> País * </label>
                      <v-autocomplete
                        placeholder="Selecciona el país del proveedor"
                        v-model="$v.form.country.$model"
                        :error="$v.form.country.$invalid && submitUpload"
                        :error-messages="
                          $v.form.country.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        :items="wrappedCountries"
                        item-text="name"
                        item-value="code"
                      ></v-autocomplete>
                    </v-col> -->
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="region"> Región * </label>
                      <v-autocomplete
                        placeholder="Selecciona la región de la empresa"
                        v-model="$v.form.region.$model"
                        :error="$v.form.region.$invalid && submitUpload"
                        :error-messages="
                          $v.form.region.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        :items="wrappedRegions"
                      ></v-autocomplete>
                    </v-col>
                    <!-- <v-col cols="12" md="6" sm="12" class="pt-0" v-if="showAllForm">
                  <label for="commune">
                    Comuna *
                  </label>
                  <v-select
                    placeholder="Selecciona la comuna de la empresa"
                    :disabled="!form.region"
                    v-model="$v.form.commune.$model"
                    :error="$v.form.commune.$invalid && submitUpload"
                    :error-messages="
                      $v.form.commune.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                    :items="communes"
                  ></v-select>
                </v-col> -->
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="city"> Ciudad *</label>
                      <v-text-field
                        placeholder="Ingresa la ciudad"
                        v-model="$v.form.city.$model"
                        :error="$v.form.city.$invalid && submitUpload"
                        :error-messages="
                          $v.form.city.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="services">
                        Tipo de Proveedor *
                      </label>
                      <v-autocomplete
                        placeholder="Selecciona el tipo de proveedor"
                        v-model="$v.form.services.$model"
                        :error="$v.form.services.$invalid && submitUpload"
                        :error-messages="
                          $v.form.services.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        :items="wrappedTypesSuppliers"
                        item-text="name"
                        item-value="name"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <v-checkbox v-model="form.is_supplier_fee" class="mt-8">
                        <template v-slot:label>
                          <h6 class="mt-2 mx-1 mb-0">
                            ¿Proveedor con boleta de Honorarios?
                          </h6>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <h4 class="mb-3 mt-5" v-if="showAllForm">
                      Información Bancaria
                    </h4>
                    <hr v-if="showAllForm" />
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      class="pt-3"
                      v-if="showAllForm"
                    >
                      <label for="bank"> Banco a Depositar * </label>
                      <v-autocomplete
                        placeholder="Selecciona el banco a depositar"
                        v-model="$v.form.bank.$model"
                        :error="$v.form.bank.$invalid && submitUpload"
                        :error-messages="
                          $v.form.bank.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        :items="allBanks"
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label class="mt-1"> Boleta / Factura *</label>
                      <v-autocomplete
                        placeholder="Selecciona una opción"
                        v-model="$v.form.type_document_payment.$model"
                        :items="allTypesDocumentPayment"
                        :error="
                          $v.form.type_document_payment.$invalid && submitUpload
                        "
                        :error-messages="
                          $v.form.type_document_payment.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        item-text="name"
                        item-value="name"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="payment_method"> Tipo de Cuenta *</label>
                      <v-autocomplete
                        placeholder="Seleccia el modo de pago"
                        v-model="$v.form.payment_method.$model"
                        :items="allPaymentMethods"
                        :error="$v.form.payment_method.$invalid && submitUpload"
                        :error-messages="
                          $v.form.payment_method.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        item-text="name"
                        item-value="name"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="account_number"> Numero de Cuenta * </label>
                      <v-text-field
                        :type="form.is_foreign ? 'text' : 'number'"
                        @keypress="validateAccountNumber"
                        @paste="validateAccountNumber"
                        placeholder="Ingresa el numero de cuenta"
                        v-model="form.account_number"
                        :error="$v.form.account_number.$invalid && submitUpload"
                        :error-messages="
                          $v.form.account_number.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="pt-0"
                      v-if="showAllForm"
                    >
                      <label for="payment_condition">
                        Condición de Pago *
                      </label>
                      <v-autocomplete
                        placeholder="Selecciona la condición de pago"
                        v-model="$v.form.payment_condition.$model"
                        :error="
                          $v.form.payment_condition.$invalid && submitUpload
                        "
                        :error-messages="
                          $v.form.payment_condition.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                        "
                        :items="allPaymentConditions"
                        item-text="name"
                        item-value="name"
                        disabled
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-form>
              </v-tab-item>
              <v-tab-item key="documentsSupplier">
                <ManagmentDocumentsSupplier
                  :currentSupplier="currentSupplier"
                  @fileUploaded="emitFileUploaded"
                  ref="managmentDocumentsSupplier"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalCreateSupplier"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            @click="sendAddSupplier"
            :color="`${currentSupplier ? 'warning' : 'primary'} text-white`"
            small
            class="float-right"
          >
            {{ currentSupplier ? "Actualizar Proveedor" : "Agregar Proveedor" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required, email, maxLength } from "vuelidate/lib/validators";
import swal2 from "sweetalert2";
import { formatToChileanRut, validateRut, rutValid } from "@/helpers/rut";
import { validatePhone } from "@/helpers/common";
import ManagmentDocumentsSupplier from "./ManagmentDocumentsSupplier.vue";

export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalCreateSupplier: {
      type: Function,
      default: () => {},
    },
    currentSupplier: {
      default: null,
    },
    showOnlyCompleteSupplier: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ManagmentDocumentsSupplier,
  },
  data() {
    return {
      tab: "formSupplier",
      loading: false,
      filesRequiredToUploadSupplier: 5,
      showAllForm: true,
      form: {
        reason_name: null,
        supplier_draft: null,
        supplier_rut: null,
        company_contact: null,
        company_phone: null,
        company_email: null,
        address: null,
        // commune: null,
        city: null,
        // country: null,
        region: null,
        services: null,
        is_supplier_fee: false,
        bank: null,
        type_document_payment: null,
        payment_method: null,
        account_number: null,
       
        // TODO: Eliminar valor por defecto una vez se definan las condiciones de pago
        payment_condition: "CREDITO 30 DIAS",
        is_foreign: false,
      },
      submitUpload: false,
    };
  },
  validations() {
    return {
      form: {
        reason_name: { required },
        supplier_draft: {
          required,
        },
        supplier_rut: this.form.is_foreign
          ? { required }
          : { required, rutValid },

        company_contact: {
          required,
        },
        company_phone: {
          required,
        },
        company_email: {
          required,
          email,
        },
        address: {
          required,
          maxLength: maxLength(50),
        },
        // commune: this.showOnlyCompleteSupplier
        //   ? {}
        //   : {
        //       required,
        //     },
        city: {},
        // country: this.form.is_foreign ? { required } : {},
        region: this.showOnlyCompleteSupplier
          ? {}
          : {
              required,
            },
        services: {
          required,
        },
        is_supplier_fee: {},
        bank: {
          required,
        },
        type_document_payment: this.showOnlyCompleteSupplier
          ? { required }
          : {},
        payment_method: this.showOnlyCompleteSupplier ? { required } : {},
        account_number: {
          required,
        },
        payment_condition: {
          required,
        },
        // is_foreign: {},
      },
    };
  },
  mounted() {
    if (!this.allRegions.length) {
      this.getRegions();
    }
    if (!this.allSupplierDrafts.length) {
      this.getListOptionsSupplier();
    }
  },
  methods: {
    validatePhone,
    ...mapActions({
      getRegions: "common/getRegions",
      updateOrCreateSupplier: "supplying/updateOrCreateSupplier",
      getListOptionsSupplier: "supplying/getListOptionsSupplier",
    }),
    validateAccountNumber(event) {
      if (this.form.is_foreign) {
        return;
      }
      const allowedCharacters = /[0-9]/;
      let textToValidate = event.key
        ? event.key
        : event.clipboardData.getData("text");
      if (!allowedCharacters.test(textToValidate)) {
        event.preventDefault();
      }
    },
    emitFileUploaded() {
      this.$emit("fileUploaded");
    },
    formatRut() {
      if (!this.form.is_foreign) {
        this.form.supplier_rut = formatToChileanRut(this.form.supplier_rut);
      } else {
        //Quita los puntos y guiones
        this.form.supplier_rut = this.form.supplier_rut;
      }
    },
    validateRutFormat(event) {
      const allowedCharacters = /[0-9.\-K]/i; // Permite números, punto, guión y "K" (mayúscula o minúscula)
      let textToValidate = event.key
        ? event.key
        : event.clipboardData.getData("text");

      if (!allowedCharacters.test(textToValidate)) {
        event.preventDefault();
      } else {
        if (!event.key) {
          this.formatRut();
        }
      }
    },
    async sendAddSupplier() {
      let self = this;
      self.submitUpload = true;
      if (!self.showAllForm || !self.$v.form.$invalid) {
        if (
          !self.form.reason_name ||
          !self.form.supplier_rut ||
          !self.form.supplier_draft
        ) {
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: "Debe completar todos los campos",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 4000,
            timerProgressBar: true,
          });
        }
        if (
          self.form.supplier_rut &&
          !validateRut(self.form.supplier_rut) &&
          !self.form.is_foreign
        ) {
          return self.$swal.fire({
            icon: "error",
            title: "Error",
            text: "El RUT debe tener un formato correcto",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        self.loading = true;
        const resp = await self.updateOrCreateSupplier({
          id: self.currentSupplier ? self.currentSupplier.id : undefined,
          completed: self.showAllForm,
          ...self.form,
          address: self.form.address.toUpperCase(),
          region: self.form.region ? self.form.region : undefined,
          city: self.form.city.toUpperCase(),
          [self.currentSupplier
            ? "official_name"
            : "name"]: self.form.reason_name.toUpperCase(),
          // commune:
          //   self.form.country && self.form.is_foreign
          //     ? self.form.country
          //     : undefined,
          rut: self.form.supplier_rut.replace(/\./g, ""),
          business_category_uuid: self.form.supplier_draft,
          contact_user_name: self.form.company_contact.toUpperCase(),
          contact_user_email: self.form.company_email,
          contact_phone: self.form.company_phone,
          service_bought: self.form.services,
          is_honorario: self.form.is_supplier_fee,
          bank_uuid: self.form.bank,
          boleta_factura: self.form.type_document_payment,
          is_foreign: self.form.is_foreign ? true : false,
          user: self.user.email,
          files:
            !self.currentSupplier && self.$refs.managmentDocumentsSupplier
              ? self.$refs.managmentDocumentsSupplier.getFiles()
              : [],
          doc_type:
            !self.currentSupplier && self.$refs.managmentDocumentsSupplier
              ? self.$refs.managmentDocumentsSupplier.getDocType()
              : {},
        });
        if (resp?.status == 200) {
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: self.currentSupplier
              ? "Proveedor modificado correctamente"
              : "Código creado correctamente, sera notificado una vez se haya creado el proveedor",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("supplierCreated");
          this.$emit("emitNameSupplier", {
            name: self.form.reason_name,
            rut: self.form.supplier_rut.replace(/\./g, ""),
          });
          this.closeModalCreateSupplier(true);
          this.resetForm();
          if (!self.currentSupplier && self.$refs.managmentDocumentsSupplier) {
            self.$refs.managmentDocumentsSupplier.resetForm();
          }
        }
        if (!resp?.status || resp?.status === 400 || resp?.status === 422) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp
              ? resp.data.detail
              : "Ha ocurrido un error de servidor, intentalo nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    executeCloseModalCreateSupplier($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        if (this.$refs.managmentDocumentsSupplier) {
          this.$refs.managmentDocumentsSupplier.resetForm();
        }
        this.$emit("resetDocumentsSelected");
        this.closeModalCreateSupplier($event);
      }
    },
    setSupplier(supplier) {
      let self = this;
      this.form = {
        reason_name: supplier.official_name,
        supplier_draft: supplier.business_category
          ? supplier.business_category.id
          : null,
        is_foreign: supplier.is_foreign,
        company_contact: supplier.contact_user_name,
        company_phone: supplier.contact_phone,
        company_email: supplier.contact_user_email,
        address: supplier.address,
        // commune: supplier.commune,
        country: supplier.commune,
        city: supplier.city,
        region: supplier.region,
        services: supplier.service_bought,
        bank: supplier.bank ? supplier.bank.id : null,
        is_supplier_fee: supplier.is_honorario,
        type_document_payment: supplier.boleta_factura,
        payment_method: supplier.payment_method,
        account_number: supplier.account_number,
        payment_condition: supplier.payment_condition,
        supplier_rut: "",
      };
      setTimeout(function() {
        self.form.supplier_rut = supplier.is_foreign
          ? supplier.rut
          : formatToChileanRut(supplier.rut);
      }, 500);
    },
    resetForm() {
      this.form = {
        reason_name: null,
        supplier_draft: null,
        supplier_rut: null,
        company_contact: null,
        company_phone: null,
        company_email: null,
        address: null,
        // commune: null,
        city: null,
        region: null,
        country: null,
        services: null,
        is_supplier_fee: false,
        bank: null,
        type_document_payment: null,
        payment_method: null,
        account_number: null,

        payment_condition: "CREDITO 30 DIAS",
        // payment_condition: null,
        is_foreign: false,
      };
      this.submitUpload = false;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      allSupplierDrafts: "supplying/allSupplierDrafts",
      allTypesSuppliers: "supplying/allTypesSuppliers",
      allBanks: "supplying/allBanks",
      allTypesDocumentPayment: "supplying/allTypesDocumentPayment",
      allPaymentMethods: "supplying/allPaymentMethods",
      allPaymentConditions: "supplying/allPaymentConditions",
      allRegions: "common/allRegions",
      allCommunes: "common/allCommunes",
    }),
    wrappedRegions() {
      return this.allRegions.map((item) => item.region);
    },
    wrappedTypesSuppliers() {
      return this.allTypesSuppliers;
    },
    wrappedCountries() {
      if (this.allRegions.find((item) => item.region === "Extranjero")) {
        return Object.entries(
          this.allRegions.find((item) => item.region === "Extranjero")?.comunas
        ).map(([key, value]) => ({ name: key, code: value }));
      }
      return [];
    },
  },
  watch: {
    currentSupplier(newForm) {
      if (newForm) {
        this.setSupplier(newForm);
      } else {
        this.resetForm();
      }
    },
    "form.is_foreign"(newIsForeign) {
      if (newIsForeign) {
        this.form.supplier_rut = null;
      } else {
        if (this.form.supplier_rut) {
          this.form.supplier_rut = formatToChileanRut(this.form.supplier_rut);
        }
      }
    },
  },
};
</script>

<style></style>